/* Claude QA 11-03: small site-wide fixes (loaded from snippets/am-qa-1103.liquid).
   1. Escape closes the menu drawer and the filter drawer (search already closed on Escape).
   2. Contact form: the email field becomes a real email field and is required (the label already
      said so); phone gets the tel keyboard. */
(function () {
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || e.defaultPrevented) return;
    var filterClose = document.querySelector('.wt-filter--drawer-open .wt-filter__close');
    if (filterClose) { filterClose.click(); return; }
    if (document.body.classList.contains('menu-open')) {
      var trigger = Array.prototype.filter.call(
        document.querySelectorAll('[aria-controls="wt-drawer-nav"]'),
        function (t) { return t.offsetParent !== null; }
      )[0];
      if (trigger) trigger.click();
    }
  });

  function fixContactForm() {
    document.querySelectorAll('form[action*="/contact"] input[name="contact[email]"]').forEach(function (input) {
      if (input.type !== 'email') input.type = 'email';
      input.required = true;
      input.setAttribute('autocomplete', 'email');
      input.setAttribute('inputmode', 'email');
    });
    document.querySelectorAll('form[action*="/contact"] input[name="contact[phone]"]').forEach(function (input) {
      if (input.type !== 'tel') input.type = 'tel';
      input.setAttribute('autocomplete', 'tel');
    });
    document.querySelectorAll('form[action*="/contact"] input[name="contact[name]"]').forEach(function (input) {
      input.setAttribute('autocomplete', 'name');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fixContactForm);
  else fixContactForm();
})();
